var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayFilled = function SvgPlayFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.2851197,48.3835785 C77.270975,50.8737056 75.8973802,53.1719206 73.7052986,54.3902114 L29.1686133,79.1132944 C28.1208864,79.6942254 26.9345566,79.9999737 25.7327688,79.9999737 C24.4976157,79.9999737 23.2808811,79.6768297 22.2102894,79.0637845 C20.0550334,77.8279657 18.7147697,75.5348909 18.7147697,73.0679146 L18.7147697,22.9316857 C18.7147697,20.4487074 20.0685222,18.1456843 22.2445107,16.9146215 C24.4068648,15.6909859 27.0816422,15.6953486 29.2416023,16.9266673 L73.7774192,42.3402949 C75.954044,43.5818483 77.2992718,45.8941335 77.2851197,48.3835785 Z",
    fill: "#ffffff",
    fillRule: "evenodd"
  })));
};
export default SvgPlayFilled;